/* One CSS ticker; no animation loop or dependency. Text remains readable without JS. */
(() => {
  const init = (root) => {
    if (root.dataset.rcbTickerReady !== undefined) return;
    const track = root.querySelector('[data-rcb-ticker-track]');
    const button = root.querySelector('[data-rcb-ticker-pause]');
    if (!track || !button) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    const sync = () => {
      root.dataset.rcbTickerRunning = String(visible && !document.hidden && !motion.matches && button.getAttribute('aria-pressed') !== 'true');
      button.hidden = motion.matches;
    };
    const measure = () => {
      if (!motion.matches) root.style.setProperty('--rcb-ticker-duration', `${track.scrollWidth / 2 / 40}s`);
    };
    root.dataset.rcbTickerReady = '';
    button.addEventListener('click', () => {
      button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      sync();
    });
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); });
    observer.observe(root);
    const resize = new ResizeObserver(measure);
    resize.observe(root);
    const preference = () => { measure(); sync(); };
    motion.addEventListener('change', preference);
    document.addEventListener('visibilitychange', sync);
    document.fonts.ready.then(() => { if (root.isConnected) measure(); });
    const unload = (event) => {
      if (!event.target.contains(root)) return;
      observer.disconnect(); resize.disconnect();
      motion.removeEventListener('change', preference);
      document.removeEventListener('visibilitychange', sync);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    measure(); sync();
  };
  const scan = () => document.querySelectorAll('[data-rcb-ticker]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
